/**
 * Logger utility for frontend application
 * Provides consistent logging across the application with different log levels
 */

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

class Logger {
  private logLevel: LogLevel;
  private isDevelopment: boolean;

  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
    this.logLevel = this.isDevelopment ? LogLevel.DEBUG : LogLevel.WARN;
  }

  private shouldLog(level: LogLevel): boolean {
    return level >= this.logLevel;
  }

  private formatMessage(level: string, _message: string, ..._args: any[]): void {
    const timestamp = new Date().toISOString();
    const _prefix = `[${timestamp}] [${level}]`;
    
    // if (args.length > 0) {
    //   console.log(prefix, message, ...args);
    // } else {
    //   console.log(prefix, message);
    // }
  }

  debug(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.DEBUG)) {
      this.formatMessage('DEBUG', message, ...args);
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.INFO)) {
      this.formatMessage('INFO', message, ...args);
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.WARN)) {
      this.formatMessage('WARN', message, ...args);
    }
  }

  error(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.ERROR)) {
      this.formatMessage('ERROR', message, ...args);
    }
  }

  // General log method (alias for info in development, warn in production)
  log(message: string, ...args: any[]): void {
    if (this.isDevelopment) {
      this.info(message, ...args);
    } else {
      this.warn(message, ...args);
    }
  }

  // Convenience method for API errors
  apiError(endpoint: string, error: any): void {
    this.error(`API Error [${endpoint}]:`, error);
  }

  // Convenience method for component errors
  componentError(component: string, error: any): void {
    this.error(`Component Error [${component}]:`, error);
  }
}

// Export singleton instance
const logger = new Logger();
export default logger;
